import { Vue, Component, Prop } from 'vue-property-decorator'
import StatisticalAnalysisViewDetailChart from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart/statistical-analysis-view-detail-chart.vue'
import { initialStatisticalAnalysisViewDetailState, StatisticalAnalysisViewDetailState } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail/statistical-analysis-view-detail.model'
import StatisticalAnalysisViewDetailTable from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-table/statistical-analysis-view-detail-table.vue'
import { StatiscalAnalysisTypeCases, StatisticalAnalysisComboTypes, StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeModeSelectorEnum, StatisticalAnalysisDossiersExternalInfo, StatisticalAnalysisViewDetailParams } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { StatisticalAnalysisTimesheetItems } from '@/modules/statistical-analysis-module/shared/services/statistical-analysis-timesheet/statistical-analysis-timesheet.dto'
import { Nullable } from '@/shared/types/app.types'
import { StatisticalAnalysisGroupingResponseField } from '@/modules/statistical-analysis-module/shared/services/statistical-analysis-grouping/statistical-analysis-grouping.dto'
import { StatisticalAnalysisViewDetailChartFilterAxisCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart-filters-axis/statistical-analysis-view-detail-chart-filters-axis.model'
import { isArray } from 'lodash'
import { StatisticalAnalysisSidebarItemCombo } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'
import { getIconHeaders, getXAxisPreselections } from '@/modules/statistical-analysis-module/shared/helpers/helpers'

@Component({
    components: {
        StatisticalAnalysisViewDetailTable,
        StatisticalAnalysisViewDetailChart
    }
})
export default class StatisticalAnalysisViewDetail extends Vue {
    @Prop() readonly timeSheetId!: Nullable<StatisticalAnalysisTimesheetItems>
    @Prop() readonly typeDelay!: StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeModeSelectorEnum
    @Prop() readonly externalInfo!: StatisticalAnalysisDossiersExternalInfo
    @Prop() readonly viewDetailParams!: StatisticalAnalysisViewDetailParams

    state: StatisticalAnalysisViewDetailState
    constructor() {
        super()
        this.state = initialStatisticalAnalysisViewDetailState()
    }

    created() {
        this.$eventHub.$on('statistical-grouping-loaded', this._onGroupingLoaded)
    }

    beforeDestroy() {
        this.$eventHub.$off('statistical-grouping-loaded', this._onGroupingLoaded)
    }

    private _onGroupingLoaded(groupings: StatisticalAnalysisGroupingResponseField[]): void {
        this.state.groupingLoaded = false
        const entitySelection = isArray(this.externalInfo.typeSearch)
            ? (this.externalInfo.typeSearch as StatisticalAnalysisSidebarItemCombo []).map((item: StatisticalAnalysisSidebarItemCombo) => item.id as StatiscalAnalysisTypeCases)
            : this.externalInfo.typeSearch?.id as StatiscalAnalysisTypeCases
        if (this.viewDetailParams.chart.axis.xAxis?.mainCombo) {
            this.viewDetailParams.chart.axis.xAxis.mainCombo.list = this._transformGroupingValues(groupings)
            this.viewDetailParams.chart.axis.xAxis.mainCombo.selected = getXAxisPreselections(
                this.viewDetailParams.chart.axis.xAxis.mainCombo.selected,
                entitySelection,
                this.viewDetailParams.chart.axis.xAxis.mainCombo.list,
                StatisticalAnalysisComboTypes.MAIN
            )
        }
        if (this.viewDetailParams.chart.axis.xAxis?.associatedCombo) {
            this.viewDetailParams.chart.axis.xAxis.associatedCombo.list = this._transformGroupingValues(groupings)
            this.viewDetailParams.chart.axis.xAxis.associatedCombo.selected = getXAxisPreselections(
                this.viewDetailParams.chart.axis.xAxis.associatedCombo.selected,
                entitySelection,
                this.viewDetailParams.chart.axis.xAxis.associatedCombo.list,
                StatisticalAnalysisComboTypes.ASSOCIATED
            )
        }
        this.state.groupingLoaded = true
    }

    private _transformGroupingValues(groupings: StatisticalAnalysisGroupingResponseField[]): StatisticalAnalysisViewDetailChartFilterAxisCombo[] {
        return groupings.map((groupingItem: StatisticalAnalysisGroupingResponseField) => {
            const group: StatisticalAnalysisViewDetailChartFilterAxisCombo = {
                id: groupingItem.fieldName,
                text: groupingItem.translatedFieldName
            }
            if (groupingItem.entity) {
                group.icon = getIconHeaders(groupingItem.entity)
            }
            return group
        })
    }
}
